module.exports = __webpack_public_path__ + "static/img/success.81509ff.svg";


//////////////////
// WEBPACK FOOTER
// ./static/image/activity-boost/success.svg
// module id = A7ej
// module chunks = 1